import { APICompsSchema, APIPaths } from "./api-config";

type BrandQuery = NonNullable<APIPaths["/admin-dash/brand/list"]["get"]["parameters"]["query"]>;
type FetchBrandPage = (query: BrandQuery) => Promise<APICompsSchema["BrandListResponse"]>;

/** 所属ブランド候補を全ページ取得する。途中失敗時は部分的な候補を返さない。 */
export const getAllOpenBrands = async (
  fetchPage: FetchBrandPage,
  organizationId?: string,
): Promise<APICompsSchema["BrandObject"][]> => {
  const brands: APICompsSchema["BrandObject"][] = [];
  const ids = new Set<string>();
  let total: number | undefined;

  do {
    const page = await fetchPage({
      status: "open",
      ...(organizationId ? { organizationId } : {}),
      sortBy: "createdAt-desc",
      offset: brands.length,
      limit: 1000,
    });

    // 件数の変動・不整合による候補の欠落や無限取得を防ぐ。再取得は呼び出し側に任せる。
    if (
      !Number.isSafeInteger(page.paging.total) ||
      page.paging.total < 0 ||
      (total !== undefined && total !== page.paging.total) ||
      page.paging.offset !== brands.length ||
      page.paging.count !== page.objects.length ||
      brands.length + page.objects.length > page.paging.total ||
      (page.objects.length === 0 && brands.length < page.paging.total)
    ) {
      throw new Error("ブランド一覧を取得できませんでした。画面を再読み込みしてください。");
    }
    total = page.paging.total;

    for (const brand of page.objects) {
      if (ids.has(brand.id)) {
        throw new Error("ブランド一覧が更新されました。画面を再読み込みしてください。");
      }
      ids.add(brand.id);
      brands.push(brand);
    }
  } while (brands.length < total);

  return brands;
};
